module.exports = __webpack_public_path__ + "static/media/popular3.7c773726.jpg";